import { render, staticRenderFns } from "./EmailCheck.vue?vue&type=template&id=505342a4&scoped=true&"
import script from "./EmailCheck.vue?vue&type=script&lang=js&"
export * from "./EmailCheck.vue?vue&type=script&lang=js&"
import style0 from "./EmailCheck.vue?vue&type=style&index=0&id=505342a4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505342a4",
  null
  
)

export default component.exports